export function copiarQuestaoParaAreaDeTransferencia(objeto) {
    // Função para verificar a existência de um valor
    function verificarExistencia(valor) {
        return valor !== null && valor !== undefined ? valor : '';
    }

    // Construir a string de conteúdo formatado dinamicamente em HTML
    let conteudoFormatado = '';

    if (objeto.imagem) {
        conteudoFormatado += `<p><a href="${objeto.imagem}" target="_blank">${objeto.imagem}</a></p>`;
    }
    if (objeto.texto) {
        conteudoFormatado += `<p>${objeto.texto}</p>`;
    }
    if (objeto.pergunta) {
        conteudoFormatado += `<p><strong>${objeto.pergunta}</strong></p>`;
    }

    const alternativas = ['a', 'b', 'c', 'd', 'e'];
    alternativas.forEach(alternativa => {
        if (objeto[alternativa]) {
            conteudoFormatado += `<div>${alternativa.toUpperCase()}) ${objeto[alternativa]}</div>`;
        }
    });

    if (objeto.gabarito) {
        conteudoFormatado += `<p>Gabarito: ${objeto.gabarito.toUpperCase()}</p>`;
    }

    // Copiando para a área de transferência com formatação HTML
    navigator.clipboard.write([
        new ClipboardItem({
            'text/html': new Blob([conteudoFormatado], { type: 'text/html' })
        })
    ]).then(() => {
        console.log('Conteúdo copiado para a área de transferência com formatação');
    }).catch(err => {
        console.error('Erro ao copiar para a área de transferência: ', err);
    });
}